import { render } from "./Confirmation.vue?vue&type=template&id=df0df194&scoped=true&ts=true"
import script from "./Confirmation.vue?vue&type=script&lang=ts"
export * from "./Confirmation.vue?vue&type=script&lang=ts"

import "./Confirmation.vue?vue&type=style&index=0&id=df0df194&scoped=true&lang=scss"

import exportComponent from "/buddy/openbanking/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df0df194"]])

export default __exports__